import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import styled from 'styled-components';

import { SEO, SEO_PAGE_TYPES } from '../../components/SEO/SEO';
import Layout from '../../components/Layout/Layout';
import Paragraphs from '../../components/Paragraphs/Paragraphs';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

class Partner extends React.Component {
  render() {
    const post = get(this.props, 'data.partner.edges[0].node');
    const partners = get(this.props, 'data.partners.edges');
    const { edges: moneyBuys } = get(this.props, 'data.allContentfulCart');
    const {
      name, paragraphs, backgroundColour
    } = post;

    // As ALL Partners are 'children' of the same 'our partners' pages, we hardcode them,
    // rather than using a per-partner field set in the CMS:
    const parentPages = [
      { title: 'About Us', path: 'about' },
      { title: 'Our Partners', path: 'about/our-partners' }
    ];

    return (
      <Layout backgroundColour={backgroundColour}>
        <Wrapper data-test="partner">

          <Breadcrumb
            thisPageTitle={name}
            parentPages={parentPages}
            backgroundColour={backgroundColour}
          />

          {paragraphs
            && (
            <Paragraphs
              paragraphs={paragraphs}
              partners={partners}
              moneyBuys={moneyBuys}
            />
            )}
        </Wrapper>
      </Layout>
    );
  }
}

export default Partner;

export const Head = props => (
  <SEO
    allData={props}
    pageType={SEO_PAGE_TYPES.PARTNER}
  />
);

export const pageQuery = graphql`
  query getPartner($slug: String, $partnerCategory: [String]) {
    partner: allContentfulPagePartner(filter: {path: {eq: $slug}}) {
      edges {
        node {
          ...PartnerList
        }
      }
    }
    partners: allContentfulPagePartner(
      sort: {weight: ASC}
      filter: {group: {title: {in: $partnerCategory}}}
    ) {
      edges {
        node {
          ...PartnerList
        }
      }
    }
    allContentfulCart {
      edges {
        node {
          cartId
          singleGiving {
            moneybuys {
              description
              value
            }
          }
          regularGiving {
            moneybuys {
              description
              value
            }
          }
        }
      }
    }
  }
`;
